function addSlideArrows() {
  const slideshowDiv = document.querySelector(
    ".homepage__hero .hero--natural"
  );
  const flickityInstance = Flickity.data(slideshowDiv);

  const prevButton = document.createElement("button");
  prevButton.className =
    "flickity-button flickity-prev-next-button flickity-previous";
  prevButton.setAttribute("type", "button");
  prevButton.setAttribute("aria-label", "Previous");
  prevButton.innerHTML =
    '<svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg>';

  const nextButton = document.createElement("button");
  nextButton.className =
    "flickity-button flickity-prev-next-button flickity-next";
  nextButton.setAttribute("type", "button");
  nextButton.setAttribute("aria-label", "Next");
  nextButton.innerHTML =
    '<svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg>';

  slideshowDiv.appendChild(prevButton);
  slideshowDiv.appendChild(nextButton);

  prevButton.addEventListener("click", function () {
    flickityInstance.previous();
  });

  nextButton.addEventListener("click", function () {
    flickityInstance.next();
  });
}

addSlideArrows();
